<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
  
<!-- Product details page media hover animation -->
  
document.addEventListener("DOMContentLoaded", function () {
  // Select all hover image wrappers
  const containers = document.querySelectorAll(".custom_hover_img_wrapper");

  containers.forEach((container) => {
    const image = container.querySelector(".custom_hover_img");

    // Add event listeners for each container
    container.addEventListener("mousemove", (event) => {
      const rect = container.getBoundingClientRect(); // Get the container's position
      const x = ((event.clientX - rect.left) / rect.width) * 100; // X-axis percentage
      const y = ((event.clientY - rect.top) / rect.height) * 100; // Y-axis percentage

      image.style.transformOrigin = `${x}% ${y}%`; // Set zoom origin
      image.style.transform = "scale(2)"; // Apply zoom effect
    });

    // Reset the zoom effect when the mouse leaves the container
    container.addEventListener("mouseleave", () => {
      image.style.transform = "scale(1)"; // Reset scale
      image.style.transformOrigin = "center center"; // Reset origin
    });
  });
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
